import PropTypes from 'prop-types';
import React from 'react';
// eslint-disable-next-line import/no-named-default
import { default as DropdownComponent } from '../../Dropdown';

export const Dropdown = (props, options, onChange) => {
  let value;
  if (typeof props === 'string') {
    value = props;
  } else if (
    typeof props === 'object' &&
    props !== null &&
    typeof props.cell.value !== 'string'
  ) {
    value = props.cell.value && Object.values(props.cell.value).join(' ');
  } else if (typeof props.cell.value === 'string') {
    value = props.cell.value;
  }

  return (
    <DropdownComponent options={options} onChange={onChange} value={value} />
  );
};

Dropdown.propTypes = {
  cell: PropTypes.object.isRequired,
};
